import { createPlacement } from '@post-office/placement-common-v2';
import { type CustomRenderer } from '@post-office/placement-common-v2/types';
import { type EligibleMessage } from '@post-office/shared-contracts/shared-request-middleware-context';
import { usePlacementApi } from '@post-office/use-placement-api';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { useEffect, useState } from 'react';

export type PlacementRenderProps = {
	hasListPreference?: boolean;
	isDetailedView?: boolean;
	targetBgColor?: string;
};

type PlacementDefinition = CustomRenderer<PlacementRenderProps>;

type AppProps = {
	targetBgColor?: string;
	hasListPreference?: boolean;
	isDetailedView?: boolean;
};

export const { createFrontend, createBackend } = createPlacement<PlacementDefinition>({
	placementId: `issue-navigator-placement`,
	options: {
		choreographer: {
			isDefaultEnabled: true,
		},
	},
});

export const PlacementFrontend = createFrontend<AppProps>((Messages) => (appProps) => {
	const { data, error, isLoading } = usePlacementApi<{
		messages: Array<EligibleMessage<Record<string, never>>>;
	}>('/');

	const [messages, setMessages] = useState<EligibleMessage<Record<string, never>>[]>([]);
	useEffect(() => {
		if (isLoading || error) {
			return;
		}
		setMessages(data.messages);
	}, [data, error, isLoading]);

	if (error || isLoading || messages.length === 0) {
		return null;
	}

	return (
		!isLoading && (
			<>
				{messages?.map?.((props) => (
					<Messages.render key={props.messageInstanceId} {...props} {...appProps} />
				))}
			</>
		)
	);
});

export const PlacementBackend = createBackend();
